export default "__VITE_ASSET__85b6b500__"